export const SYSTEM_ROLES = {
  ADMIN: "ROLE_ADMIN",
  SALE_MANAGER: "ROLE_SALE_MANAGER",
  ACCOUNT_EXECUTIVE: "ROLE_ACCOUNT_EXECUTIVE",
  MARKETING: "ROLE_MARKETING",
  SDR: "ROLE_SDR",
}